module.exports = __webpack_public_path__ + "img/neubau1-.265e913a.jpeg";